import PermissionsData from './PermissionsData';

export default PermissionsData;
